import React from "react";
import { useFormik } from "formik";
import { formikSignUp } from "./Constant";
import "../../custome.style.css";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";

function SignUp() {
  const formik = useFormik({
    ...formikSignUp,
    onSubmit: async () => { }
  });

  return (
    <div className="page-wrapper full-page create_block sign_up_blk">
      <div className="header-wrapper w-nav">
        <div className="container-default w-container">
          <div className="header-content-wrapper">
            <div className="header-middle header-v3">
              <a href="/home-pages/home-v1">
              <img src="/assets/icons/group_logo_carematics.svg" alt="text_logo" className="logo_png" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="section sign-in-section">
        <div className="image-container sign-in-section">
          <div className="image-wrapper shape section-hero---sign-in---shape-01">
            <img
              src="/assets/icons/WELCOME-YELLOW-CIRCLE.svg"
              alt=""
            />
          </div>
          <div className="position-absolute sign-in-shape-wrapper">
            <div className="image-wrapper shape section-hero---sign-in---shape-02">
              <img
                src="/assets/icons/WELCOME-BLUE-LINES.svg"
                alt=""
              />
            </div>
            <div className="image-wrapper transform-origin-bottom">
              <img
                src="/assets/icons/WELCOME-RED-CIRCLE.svg"
                alt=""
              />
            </div>
            <div className="image-wrapper">
              <img
                src="/assets/icons/WELCOME-RECTANGLE.svg"
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="container-default z-index-1 width-100 w-container">
          <div className="inner-container _640px center">
            <div className="text-center mg-bottom-48px">
              <h1 className="display-1 mg-bottom-8px welcom_blk mt-5">
                Create account
              </h1>
              <p className="color-neutral-700 mg-bottom-0 welcom_desc">
              Lorem ipsum dolor consectetur fermentum quis mi morbi adipiscing elitut aliquam purus sit amet luctus venen.
              </p>
            </div>
            <div className="card sign-up-form shadow-02 w-form login_form">
              <Form onSubmit={formik.handleSubmit}  className="form_block">
                <FormGroup className="spacing_three">
                  <Input
                    id="exampleName"
                    name="email"
                    placeholder="Full Name"
                    type="name"
                  />
                  <img src="/assets/icons/profile_welcom.svg" alt="text_logo" />
                </FormGroup>
                <FormGroup className="spacing_three">
                  <Input
                    id="exampleEmail"
                    name="email"
                    placeholder="Email address"
                    type="email"
                  />
                  <img src="/assets/icons/welcom-email.svg" alt="text_logo" />
                </FormGroup>
                <FormGroup className="spacing_three">
                  <Input
                    id="exampleNumber"
                    name="number"
                    placeholder="Phone Number"
                    type="number"
                  />
                </FormGroup>
                <FormGroup className="spacing_three">
                  <Input
                    id="examplePassword"
                    name="password"
                    placeholder="Password"
                    type="password"
                  />
                  <img src="/assets/icons/lock.svg" alt="text_logo" />
                </FormGroup>
                <FormGroup className="spacing_three">
                  <Input
                    id="confirmPassword"
                    name="password"
                    placeholder="Confirm password"
                    type="password"
                  />
                  <img src="/assets/icons/lock.svg" alt="text_logo" />
                </FormGroup>
                <div className="d-flex justify-content-between align-items-center">
                  <FormGroup check className="gap-4 d-flex">
                    <Input type="checkbox" />
                    {" "}
                    <Label check className="terms_blk">
                      I have read and accepted the CareMatics <a href="/">Terms & Conditions</a> and <a href="/">Privacy Policy.</a>
                    </Label>
                  </FormGroup>
                </div>
                <Button className="spacing_four">
                Create account
                </Button>
                <p className="text-center mt-2">Have an account? <a href="/">Sign in</a></p>
              </Form>
            </div>
          </div>
        </div>
      </div>

      <footer>
        <p>Copyright © 2024 AimCare LLC</p>
      </footer>
    </div>
  );
}
export default SignUp;
